<template>
  <div
    :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible', selected ? 'border-purple-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']"
  >
    <!-- Header del nodo -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-purple-400">code</span>
        <strong class="text-white">{{ $t('flowEditor.nodes.executeCodeNode.title') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    
    <!-- Corpo del nodo -->
    <div class="p-3">
      <p class="text-gray-300 text-sm truncate">
        <!-- Mostra un'anteprima del codice o un placeholder -->
        {{ data.code && data.code.length > 0 ? data.code.split('\n')[0] : $t('flowEditor.nodes.executeCodeNode.emptyPlaceholder') }}
      </p>
    </div>

    <!-- Punti di connessione (Handles) -->
    <Handle type="target" :position="Position.Left" />
    <Handle type="source" :position="Position.Right" />
    <!-- Add node button -->
    <AddNodeButton v-if="!hasOutgoingEdge" @add="emit('add-node', nodeId)" />
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';

const emit = defineEmits(['add-node']);

defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  nodeId: { type: String, required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>

